import { ArticleType } from 'helpers/strapi/types'
import { ArticlesPreview } from 'routes/Articles/components/ArticlePreview'
import { HeadMetatags } from 'routes/components/HeadMetatags'
import { JsonViewer } from 'routes/components/JsonViewer'
import { InnerPageLayout } from '../layouts'
import { ArticlesGrid } from './components/ArticlesGrid'
import { LINKS } from 'routes/constants'

export function ArticlesPage({ articles }: { articles: ArticleType[] }) {
  return (
    <InnerPageLayout>
      <HeadMetatags
        title={'Blog'}
        description={
          'Exploring seamless connections and collaborative systems through in-depth articles on External App Integrations, API Synergies, Data Harmonization, and more.'
        }
      >
        <link
          key='canonical'
          rel='canonical'
          href={`${process.env.NEXT_PUBLIC_SITE_URI}${LINKS.ARTICLES}`}
        />
      </HeadMetatags>
      <div className={'max-w-4xl'}>
        <h1>Blog</h1>
        <p>
          Discover tips, case studies, guides, comparisons, technical unique
          gems & more about integrations through the lens of our team.
        </p>
      </div>
      <ArticlesGrid>
        {articles.map((article, i) => (
          <ArticlesPreview
            variant={i === 0 ? 'large' : 'small'}
            article={article}
            key={article.slug}
          />
        ))}
      </ArticlesGrid>
      <JsonViewer json={articles} />
    </InnerPageLayout>
  )
}
